import { render, staticRenderFns } from "./ViewAllRequest.vue?vue&type=template&id=2481f3de&scoped=true&"
import script from "./ViewAllRequest.vue?vue&type=script&lang=js&"
export * from "./ViewAllRequest.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllRequest.vue?vue&type=style&index=0&id=2481f3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481f3de",
  null
  
)

export default component.exports